import Icon from '@/components/Icon/Icon'
import Text from '@/components/Text/Text'
import clsx from 'clsx'
import React from 'react'

type Props = {
  className?: string
  children: React.ReactNode
}

export default function MessageBox(props: Props) {
  return (
    <div
      className={clsx(
        'flex flex-row bg-gray-100 gap-2 p-2 rounded-[8px] items-start',
        props.className,
      )}
    >
      <Icon name="Info" color="grey-500" size={16} />
      <Text variant="body4" className="!text-xs">
        {props.children}
      </Text>
    </div>
  )
}
